import React from 'react';
import LandscapePaperLayout from '../@common/landscape/LandscapePaperLayout';
import GridWithText from '../@common/GridWithText';
import { WorksheetBaseProps } from '../@types';

type WordsAndSpellingProps = WorksheetBaseProps & {
  value: string;
};

const WordCardsPreKto1 = ({ onChange, valueMap, printRef }: WordsAndSpellingProps) => {
  const handleChange = (key, value) => {
    onChange({
      [key]: value
    });
  };

  return (
    <LandscapePaperLayout isWide printRef={printRef}>
      <GridWithText
        showLineToggle
        numOfCols={3}
        numOfRows={5}
        handleChange={handleChange}
        valueMap={valueMap}
        width={325}
        height={150}
        isWide
        textLinePaddingTop={60}
        className="print-margin-top-negative-10"
      />
    </LandscapePaperLayout>
  );
};

export default WordCardsPreKto1;
